import React from 'react'
import { Box, Button, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { useAdminSignIn } from '../../../hooks/useAdminSignIn';


const AdminLoginForm = () => {;


  const {isLoading, handleSubmit, errors, apiError, formData, onChange, showPassword, handleClickShowPassword} = useAdminSignIn()


const handleSubmitForm = (e) =>{
  e.preventDefault();
  handleSubmit()
}
  return (
    <>
    <form onSubmit={handleSubmitForm}>
    <Grid item xs={12} md={12} sx={{ marginBottom: '20px' }}>
        <TextField
          fullWidth
          value={formData?.email || ''}
          placeholder="Enter Email ID"
          error={!!errors?.email}
          helperText={errors?.email}
          onChange={(e) => onChange('email', e.target.value)}

          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <box-icon type="solid" name="user-rectangle"></box-icon>
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField
          fullWidth
          type={showPassword ? 'text' : 'password'}
          placeholder="Password"
          value={formData?.password || ''}
          error={!!errors?.password}
          helperText={errors?.password}
          onChange={(e) => onChange('password', e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{ marginLeft: '10px', marginRight: '10px' }}
              >
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid xs={12} sx={{ marginTop: '20px' }}>
        <Button
        type='submit'
          sx={{ borderRadius: '0' }}
          fullWidth
          // onClick={validateLogin}
          className="btn-default"
          // onClick={handleSubmit}
          disabled={isLoading}
          
        >
          {isLoading ? 'Loading...' : "Login"}
        </Button>
      </Grid>
      </form>
   <div>
      
      {apiError && (
        <p className='error'>{apiError}</p>
      )}
    </div>
      </>
  )
}

export default AdminLoginForm
